import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Product, ProductCat } from 'data/e-commerce/products';
import ProductCard from 'components/common/ProductCard';
import Swiper from 'components/base/Swiper';
import { SwiperSlide } from 'swiper/react';
import { Col, Row } from 'react-bootstrap';
import { useAppContext } from 'providers/AppProvider';
import ProductCardCat from 'components/common/ProductCardCat';
import { Brand } from 'api/categories/_requests';
import BrandScrollableCard from 'components/common/BrandScrollableCard';

interface EcomCategoryWiseProductsProps {
  products: ProductCat[];
  category: string;
  brands: Brand[];
}

const EcomCategoryWiseProducts = ({
  products,
  category,
  brands
}: EcomCategoryWiseProductsProps) => {
  const {
    config: { theme }
  } = useAppContext();

  return (
    <div
      className={`bg-light rounded-3 p-4 ${theme === 'dark' ? 'bg-dark' : ''}`}
    >
      <div className="mb-4">
        <h3 className="mb-6 mt-2 fs-4">{category}</h3>
        <BrandScrollableCard brands={brands} />
      </div>
      <Swiper
        slidesPerView={1}
        spaceBetween={16}
        navigationPosition={{ top: '25%' }}
        breakpoints={{
          0: {
            slidesPerView: 1,
            spaceBetween: 16
          },
          450: {
            slidesPerView: 2,
            spaceBetween: 16
          },
          576: {
            slidesPerView: 3,
            spaceBetween: 20
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 20
          },
          992: {
            slidesPerView: 5,
            spaceBetween: 20
          },
          1200: {
            slidesPerView: 5,
            spaceBetween: 16
          }
        }}
      >
        {products.map(product => (
          <SwiperSlide key={product._id}>
            <ProductCardCat product={product} setProduct={() => {}} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default EcomCategoryWiseProducts;
